"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getters = {};

function rules(name, getter) {
  if (!name) {
    return getters;
  }

  if (getters[name] && getter) {
    throw Error("the rule name '".concat(name, "' has been used"));
  }

  if (getter) {
    getters[name] = getter;
  }

  return getters[name];
}

var _default = rules;
exports["default"] = _default;